import { Button } from "@/components/ui/button";
import { X, Gift } from "lucide-react";

export function ExitPopup({ show, onClose, remainingSlots, onScrollToForm }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm" data-testid="exit-popup">
      <div className="relative bg-[#121212] border border-[#1a1a1a] p-8 max-w-md mx-4">
        <button onClick={onClose}
          className="absolute top-4 right-4 text-zinc-600 hover:text-white transition-colors"
          data-testid="close-popup">
          <X className="w-6 h-6" />
        </button>

        <div className="text-center">
          <div className="w-16 h-16 mx-auto bg-[#00FF66]/10 border border-[#00FF66]/30 rounded-full flex items-center justify-center mb-4">
            <Gift className="w-8 h-8 text-[#00FF66]" />
          </div>

          <h3 className="text-2xl font-bold font-['Clash_Display',sans-serif] text-white mb-2">
            Attendez !
          </h3>

          <p className="text-zinc-400 mb-4 font-['Outfit',sans-serif]">
            Ne partez pas sans votre cadeau...
          </p>

          <div className="bg-[#00FF66] text-black p-4 mb-6">
            <p className="text-3xl font-black font-['Clash_Display',sans-serif]">-500€ HT</p>
            <p className="text-sm font-['Outfit',sans-serif]">sur votre première enseigne</p>
          </div>

          <p className="text-sm text-zinc-400 mb-6 font-['Outfit',sans-serif]">
            Offre valable uniquement cette semaine.<br />
            <span className="text-[#00FF66] font-bold">Plus que {remainingSlots} places !</span>
          </p>

          <Button
            onClick={() => { onClose(); onScrollToForm(); }}
            className="w-full bg-[#00FF66] text-black hover:bg-[#00dd55] h-12 font-bold rounded-none uppercase tracking-wider"
            data-testid="popup-cta">
            Je profite de l'offre
          </Button>

          <button onClick={onClose}
            className="mt-4 text-sm text-zinc-600 hover:text-zinc-400 transition-colors">
            Non merci, je préfère payer plein tarif
          </button>
        </div>
      </div>
    </div>
  );
}
